import 'react-toastify/dist/ReactToastify.min.css';
import { createGlobalStyle } from '~/modules';

export default createGlobalStyle`
  @import url('https://fonts.googleapis.com/css?family=Poppins:400,500,700,900');
  * {
    padding: 0;
    margin: 0;
    outline: 0;
    box-sizing: border-box;
  }
  html, body, #app {
    height: 100%;
    margin: 0;
    padding: 0;
    background: #E2E5FF;
  }
  body {
    color: #131264;
    min-height: 100vh;
    min-height: -webkit-fill-available;
    width: 100%;
    font-family: 'Poppins', sans-serif;
    text-rendering: optimizeLegibility !important;
    overscroll-behavior: contain;
    scrollbar-width: none;
    -webkit-font-smoothing: antialiased !important;
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
    display: flex;
    flex-direction: column;
    @media print {
      visibility: hidden;
    }
  }
  html {
    min-height: -webkit-fill-available;
    width: 100%;
  }
  input, button {
    font-family: 'Poppins', sans-serif;
  }
  button {
    cursor: pointer;
  }
  div {
    display: flex;
  }
  ::-webkit-scrollbar {
    display: none;
  }
  .MuiTypography-body1,
  .MuiTypography-caption,
  .MuiFormLabel-root,
  .MuiTypography-button,
  .MuiTypography-root {
    font-family: 'Poppins', sans-serif;
  }
  #app {
    min-height: -webkit-fill-available;
    width: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
  }
`;
